let lastScrollTop = 0;
let first_init = true;
let delta = 5;
const header = $('.site-header');
const body = $('body');
const navbar = $('#navbar');
let navHeight = header.outerHeight();
let main_page_wrap = $('.main-page-wrap');
let item_has_child = $('#menu-main-menu li.menu-item-has-children')

if (!main_page_wrap.length > 0 || !main_page_wrap.find('>section').length > 0 || !main_page_wrap.find('>section').eq(0).hasClass('section-hero')) {
    header.addClass('-filled -filled-start');
}
checkFilled();
$(window).on('scroll', function () {
    checkFilled();
    hasScrolled();
});
$(window).resize(function () {
    navbar.collapse('hide');
    $('.sub-menu').removeAttr('style');
    item_has_child.removeClass('-open');
});

function hasScrolled() {
    let st = $(window).scrollTop();

    if (st <= 64 || first_init) {
        first_init = false;
        return;
    }

    if (st > lastScrollTop && st > navHeight) {
        header.removeClass('-down').addClass('-up');
        lastScrollTop = st;
    } else if (st + $(window).height() < $(document).height()) {
        header.removeClass('-up').addClass('-down');
        lastScrollTop = st;
    }

}

function checkFilled() {
    let scrollTop = $(window).scrollTop();

    if (scrollTop > 64) {
        if (!header.hasClass('-filled-start')) {
            header.addClass('-filled');
        }
        header.removeClass('-top');
    } else {
        if (!header.hasClass('-filled-start')) {
            header.removeClass('-filled');
        }
        header.addClass('-top');
    }
}


navbar.on('show.bs.collapse', function () {
    header.addClass('open-menu');
    body.addClass('overflow-hidden');
});
navbar.on('hide.bs.collapse', function () {
    header.removeClass('open-menu');
    body.removeClass('overflow-hidden');
});


item_has_child.on('click', function (e) {
    if (e.target !== this) return;
    let this_li = $(this);
    if (!this_li.hasClass('-open')) {
        this_li.find('> .sub-menu').slideDown();
        this_li.addClass('-open');
    } else {
        this_li.find('> .sub-menu').slideUp();
        this_li.removeClass('-open');
    }
});
$('#menu-main-menu li.menu-item-has-children > a[href="#"], #menu-main-menu li.menu-item-has-children > a:not([href])').on('click', function (e) {
    e.preventDefault();
    let this_li = $(this).parent();
    if (!this_li.hasClass('-open')) {
        this_li.find('> .sub-menu').slideDown();
        this_li.addClass('-open');
    } else {
        this_li.find('> .sub-menu').slideUp();
        this_li.removeClass('-open');
    }
});